String.prototype.urlFormat = function (data = []) {
    return stringReplace(this, "{.*?}", data);
}

const stringReplace = (str = '', regExp, replaceData = []) => {
    let a = str.match(new RegExp(`${regExp}`, 'g'));
    if (a && a.length > 0) {
        console.log(a.length)
        replaceData.forEach((item) => {
            str = str.replace(new RegExp(`${regExp}`, ''), item)
        })
    }
    return str;
}

export const getBrowserType = () =>{
    let ua = navigator.userAgent.toLowerCase();
    if(ua.indexOf("micromessenger") != -1) return "wechat"
    if(ua.indexOf("qjwpro") != -1) return "app"
    return "h5"
}


export const showMeiQia = () => {
    if(getBrowserType() === "app"){
        window.$mobile.showMeiQia()
    }else{
        if (!window._MEIQIA) initMeiQia();
        window._MEIQIA('showPanel');
    }
}
export const showXiaoNeng = (settingid) =>{
    if (!settingid)
        settingid = 'kf_20009_template_10'
  window.location.href = process.env.CONFIG.xiaoNengLink + settingid
}
export const showKFService = () =>{
    window.location.href = process.env.CONFIG.kefuUrl
}
export const initMeiQia = () => {
    (function (m, ei, q, i, a, j, s) {
        m[i] = m[i] || function () {
            (m[i].a = m[i].a || []).push(arguments)
        };
        j = ei.createElement(q);
        s = ei.getElementsByTagName(q)[0];
        j.async = true;
        j.charset = 'UTF-8';
        j.src = 'https://static.meiqia.com/dist/meiqia.js?_=t';
        s.parentNode.insertBefore(j, s);
    })(window, document, 'script', '_MEIQIA');
    window._MEIQIA('entId', 4229);
    window._MEIQIA('withoutBtn');
}

export const base64_encode = str => {
    var c1, c2, c3
    var base64EncodeChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
    var i = 0,
      len = str.length,
      strin = ''
    while (i < len) {
      c1 = str.charCodeAt(i++) & 0xff
      if (i === len) {
        strin += base64EncodeChars.charAt(c1 >> 2)
        strin += base64EncodeChars.charAt((c1 & 0x3) << 4)
        strin += '=='
        break
      }
      c2 = str.charCodeAt(i++)
      if (i === len) {
        strin += base64EncodeChars.charAt(c1 >> 2)
        strin += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4))
        strin += base64EncodeChars.charAt((c2 & 0xF) << 2)
        strin += '='
        break
      }
      c3 = str.charCodeAt(i++)
      strin += base64EncodeChars.charAt(c1 >> 2)
      strin += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4))
      strin += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6))
      strin += base64EncodeChars.charAt(c3 & 0x3F)
    }
    return strin
  }

  // eslint-disable-next-line no-extend-native
Date.prototype.format = function(fmt) {
    var o = {
      'y+': this.getFullYear(),
      'M+': this.getMonth() + 1, // 月份
      'd+': this.getDate(), // 日
      'h+': this.getHours(), // 小时
      'm+': this.getMinutes(), // 分
      's+': this.getSeconds(), // 秒
      'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
      'S': this.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
    for (var k in o) { if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
    return fmt
  }

  Date.prototype.diff = function(beginTime) {
    let dateBegin = new Date(beginTime);
    let dateEnd = this;
    let total = (dateEnd.getTime() - dateBegin.getTime()) / 1000;//时间差的总秒数
    let day = parseInt(total / (24 * 3600));
    let hour = parseInt(total / 3600 % 24);
    let minute = parseInt(total / 60 % 60);
    let second = parseInt(total % 60);
    return { day, hour, minute, second };
  }

Array.prototype.toMap = function (mapKey) {
  let map = {}
  this.forEach(item => {
    let key = mapKey(item).toString()
    map[key] = item
  })
  return map
}

export const dataBase64toBlob=(dataurl) =>{
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: mime,
  });
}
export const	GetRequest= (url) => {
		let query = {};
		if (url.indexOf("?") != -1) {
			const str = url.split('?');
			const pairs = str[1].split("&");
			for (let i = 0; i < pairs.length; i++) {
				const pair = pairs[i].split("=");
				query[pair[0]] = pair[1];
			}
		}
		return query; // 返回对象
	}